import { useLocation, useNavigate } from 'react-router-dom';

function useHashTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const typeId = location.hash.slice(1);
  function toTab(tab) {
    navigate(`#${tab}`, { replace: true });
  }
  return { typeId, toTab };
}

export default useHashTabs;
